export default __webpack_public_path__ + "static/media/DOCTORCERTIFICATEFOR5DISEASES.303aba4d.png";